"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.nearbySagas = void 0;
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var NearbymapState_1 = require("@/pages/common/states/NearbymapState");
var NearbyAction_1 = require("@/pages/detail/actions/NearbyAction");
var ProfileApiSaga_1 = require("@/pages/detail/api/ProfileApiSaga");
var NearbyCallSaga_1 = require("@/pages/detail/sagas/NearbyCallSaga");
var DetailPopNearbyTabType_1 = require("@/pages/detail/states/DetailPopNearbyTabType");
var NearbyCommuteEstimatorState_1 = require("@/pages/detail/states/NearbyCommuteEstimatorState");
var locationsToPoints_1 = require("@/transformers/locationsToPoints");
var format_1 = require("@/utils/format");
var effects_1 = require("redux-saga/effects");
var NearbyCommuteMethods_1 = require("../states/NearbyCommuteMethods");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var BigPopupState_1 = require("@/pages/common/states/BigPopupState");
var LayoutAction_1 = require("@/pages/common/actions/LayoutAction");
var SignupAction_1 = require("@/pages/common/actions/SignupAction");
var propertyToUrl_1 = require("@/transformers/propertyToUrl");
var savedResultItemsToNearbyResultItem_1 = require("@/transformers/savedResultItemsToNearbyResultItem");
var GoogleMapLocationSaga_1 = require("@/pages/common/sagas/GoogleMapLocationSaga");
var WindowApi_1 = require("@/api/browser/WindowApi");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var getCenter = function (state) {
    return state.detail.nearbyMap.big.mapState.center;
};
var getProperties = function (state) { return state.detail.nearbyMap.big.properties; };
var getNearbyProperties = function (state) { return state.detail.available.results; };
var getProeprtyByObject = function (state, object) {
    return state.detail.nearbyMap.big.properties.find(function (it) { return it.position.lat === object.center.lat &&
        it.position.lng === object.center.lng &&
        object.value === it.price; });
};
var getUniqueLocationsBig = function (state) {
    return state.detail.nearbyMap.big.objects
        .map(function (it) { return "" + it.center.lat + it.center.lng; })
        .filter(function (it, i, arr) {
        return arr.indexOf(it) === i;
    });
};
var getUniqueLocationsSmall = function (state) {
    return state.detail.nearbyMap.small.objects
        .map(function (it) { return "" + it.center.lat + it.center.lng; })
        .filter(function (it, i, arr) {
        return arr.indexOf(it) === i;
    });
};
var getObjectCenter = function (state) {
    return state.detail.nearbyMap.big.objects[0].center;
};
var getKeyword = function (state) {
    return state.detail.nearbyEstimator.keyword;
};
var getIsSelectingItem = function (state) {
    return state.detail.nearbyEstimator.isSelecting;
};
var getPropertyLocation = function (state) { return ({
    lat: state.detail.property.lat,
    lng: state.detail.property.lng,
}); };
var getCommuteMethod = function (state) {
    return state.detail.nearbyEstimator.commuteMethod;
};
var getSelectdPlace = function (state) {
    return state.detail.nearbyEstimator.selectedPlace;
};
var getMapObjects = function (state) {
    return state.detail.nearbyMap.big.objects;
};
var getTranslate = function (state) { return state.detail.t; };
var getCurrentFilter = function (state) { return state.detail.popNearbyTab; };
var getCurrentPlace = function (state) { return state.detail.nearbyEstimator.selectedPlace; };
var getSavedPlaces = function (state) { return state.detail.nearbyMap.big.savedPlaces; };
var getResultItems = function (state) {
    return state.detail.nearbyMap.big.results;
};
var getLocalFavProperties = function (state) { return state.sfav.sectionFav.items; };
var getLocalHistory = function (state) { return state.sfav.sectionHistory.items; };
var getCurrencyOptions = function (state) { return state.layout.currencies.options; };
var getCurrentPopNearbyTab = function (state) {
    return state.detail.popNearbyTab;
};
var fitBounds = function () {
    var locations, center;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(getUniqueLocationsBig)];
            case 1:
                locations = _a.sent();
                if (!(locations.length === 1)) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.select(getObjectCenter)];
            case 2:
                center = _a.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapCenter(center))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapZoom(15))];
            case 4:
                _a.sent();
                return [2 /*return*/];
            case 5: return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapZoom(-1))];
            case 6:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var fitSmallMapBounds = function () {
    var locations, center;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(getUniqueLocationsSmall)];
            case 1:
                locations = _a.sent();
                if (!(locations.length === 1)) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.select(NearbyCallSaga_1.getPropertyPosition)];
            case 2:
                center = _a.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setSmallMapCenter(center))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setSmallMapZoom(16))];
            case 4:
                _a.sent();
                return [2 /*return*/];
            case 5: return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setSmallMapZoom(-1))];
            case 6:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var getNearbyPropertyiesMapObjects = function (properties) {
    var propertyCenter, propertyName, mapObjects, propertyPin;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(NearbyCallSaga_1.getPropertyPosition)];
            case 1:
                propertyCenter = _a.sent();
                return [4 /*yield*/, effects_1.select(NearbyCallSaga_1.getPropertyName)];
            case 2:
                propertyName = _a.sent();
                mapObjects = properties.map(function (it) { return ({
                    kind: NearbymapState_1.NearbymapObjectKind.PRICETAG,
                    center: it.position,
                    title: format_1.default.currency(it.price),
                    value: it.price,
                    active: it.active,
                }); });
                propertyPin = {
                    kind: NearbymapState_1.NearbymapObjectKind.PIN,
                    center: propertyCenter,
                    title: propertyName,
                };
                mapObjects.push(propertyPin);
                return [2 /*return*/, mapObjects];
        }
    });
};
var watchFilterClick = function () {
    var payload, filter, center, propertyCenter, _a, nearbys, currencyId, nearbySavedItems, currencyMap, googleApiKey, properties, mapObjects, isGuest, places, result, mapObjects, propertyPin, items, currencies, googleApiKey, places, mapObjects, items, currencies, googleApiKey, places, mapObjects, results, icon, mapObjects;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!true) return [3 /*break*/, 68];
                return [4 /*yield*/, effects_1.take(NearbyAction_1.default.NEARBY_FILTER_CLICK)];
            case 1:
                payload = (_b.sent()).payload;
                filter = payload;
                return [4 /*yield*/, effects_1.select(getCenter)];
            case 2:
                center = _b.sent();
                return [4 /*yield*/, effects_1.select(NearbyCallSaga_1.getPropertyPosition)];
            case 3:
                propertyCenter = _b.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapObjects([]))];
            case 4:
                _b.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapCenter(center))];
            case 5:
                _b.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapZoom(15))];
            case 6:
                _b.sent();
                return [4 /*yield*/, effects_1.delay(200)];
            case 7:
                _b.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapCenter(propertyCenter))];
            case 8:
                _b.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setNearbyMore(false))];
            case 9:
                _b.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.showAddPlace(false))];
            case 10:
                _b.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setIsSuggesting(false))];
            case 11:
                _b.sent();
                _a = filter;
                switch (_a) {
                    case DetailPopNearbyTabType_1.DetailPopNearbyTabType.PROPERTIES: return [3 /*break*/, 12];
                    case DetailPopNearbyTabType_1.DetailPopNearbyTabType.MYPLACE: return [3 /*break*/, 27];
                    case DetailPopNearbyTabType_1.DetailPopNearbyTabType.FAVORITES: return [3 /*break*/, 39];
                    case DetailPopNearbyTabType_1.DetailPopNearbyTabType.HISTORY: return [3 /*break*/, 49];
                }
                return [3 /*break*/, 59];
            case 12: return [4 /*yield*/, effects_1.select(getNearbyProperties)];
            case 13:
                nearbys = _b.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentCurrency)];
            case 14:
                currencyId = _b.sent();
                return [4 /*yield*/, effects_1.call(savedResultItemsToNearbyResultItem_1.transformResultToSavedResult, nearbys, currencyId)];
            case 15:
                nearbySavedItems = _b.sent();
                return [4 /*yield*/, effects_1.select(getCurrencyOptions)];
            case 16:
                currencyMap = _b.sent();
                return [4 /*yield*/, effects_1.select(GoogleMapLocationSaga_1.getGoogleApiKey)];
            case 17:
                googleApiKey = _b.sent();
                return [4 /*yield*/, effects_1.call(savedResultItemsToNearbyResultItem_1.savedResultItemsToNearbyProperties, nearbySavedItems, currencyMap, googleApiKey)];
            case 18:
                properties = _b.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setNearbyProperties(properties))];
            case 19:
                _b.sent();
                return [4 /*yield*/, effects_1.call(getNearbyPropertyiesMapObjects, properties)];
            case 20:
                mapObjects = _b.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapObjects(mapObjects))];
            case 21:
                _b.sent();
                return [4 /*yield*/, effects_1.delay(1000)];
            case 22:
                _b.sent();
                if (!(mapObjects.length > 1)) return [3 /*break*/, 24];
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapZoom(-2, propertyCenter))];
            case 23:
                _b.sent();
                _b.label = 24;
            case 24:
                if (!(mapObjects.length === 1)) return [3 /*break*/, 26];
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapZoom(14.9))];
            case 25:
                _b.sent();
                _b.label = 26;
            case 26: return [3 /*break*/, 67];
            case 27: return [4 /*yield*/, effects_1.select(stateFilter_1.isUserGuest)];
            case 28:
                isGuest = _b.sent();
                places = [];
                if (!!isGuest) return [3 /*break*/, 31];
                return [4 /*yield*/, effects_1.call(ProfileApiSaga_1.getPlacesApiSaga)];
            case 29:
                result = _b.sent();
                if (!result) return [3 /*break*/, 31];
                return [4 /*yield*/, effects_1.call(locationsToPoints_1.transformLocationsToNearbyResultItems, result.data.places)];
            case 30:
                places = _b.sent();
                _b.label = 31;
            case 31: return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setSavedPlaces(places))];
            case 32:
                _b.sent();
                mapObjects = places.map(function (it) { return ({
                    kind: NearbymapState_1.NearbymapObjectKind.WINDOW,
                    center: it.position,
                    title: it.price ? format_1.default.currency(it.price) : it.name,
                }); });
                propertyPin = {
                    kind: NearbymapState_1.NearbymapObjectKind.PIN,
                    center: propertyCenter,
                };
                mapObjects.push(propertyPin);
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapObjects(mapObjects))];
            case 33:
                _b.sent();
                return [4 /*yield*/, effects_1.delay(200)];
            case 34:
                _b.sent();
                if (!(mapObjects.length > 1)) return [3 /*break*/, 36];
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapZoom(-2, JSON.parse(JSON.stringify(propertyCenter))))];
            case 35:
                _b.sent();
                _b.label = 36;
            case 36:
                if (!(mapObjects.length === 1)) return [3 /*break*/, 38];
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapZoom(14.9))];
            case 37:
                _b.sent();
                _b.label = 38;
            case 38: return [3 /*break*/, 67];
            case 39: return [4 /*yield*/, effects_1.select(getLocalFavProperties)];
            case 40:
                items = _b.sent();
                return [4 /*yield*/, effects_1.select(getCurrencyOptions)];
            case 41:
                currencies = _b.sent();
                return [4 /*yield*/, effects_1.select(GoogleMapLocationSaga_1.getGoogleApiKey)];
            case 42:
                googleApiKey = _b.sent();
                return [4 /*yield*/, effects_1.call(savedResultItemsToNearbyResultItem_1.savedResultItemsToNearbyProperties, items, currencies, googleApiKey)];
            case 43:
                places = _b.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setNearbyProperties(places))];
            case 44:
                _b.sent();
                return [4 /*yield*/, effects_1.call(getNearbyPropertyiesMapObjects, places)];
            case 45:
                mapObjects = _b.sent();
                if (!(mapObjects.length > 1)) return [3 /*break*/, 47];
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapZoom(-2, propertyCenter))];
            case 46:
                _b.sent();
                _b.label = 47;
            case 47: return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapObjects(mapObjects))];
            case 48:
                _b.sent();
                return [3 /*break*/, 67];
            case 49: return [4 /*yield*/, effects_1.select(getLocalHistory)];
            case 50:
                items = _b.sent();
                return [4 /*yield*/, effects_1.select(getCurrencyOptions)];
            case 51:
                currencies = _b.sent();
                return [4 /*yield*/, effects_1.select(GoogleMapLocationSaga_1.getGoogleApiKey)];
            case 52:
                googleApiKey = _b.sent();
                return [4 /*yield*/, effects_1.call(savedResultItemsToNearbyResultItem_1.savedResultItemsToNearbyProperties, items, currencies, googleApiKey)];
            case 53:
                places = _b.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setNearbyProperties(places))];
            case 54:
                _b.sent();
                return [4 /*yield*/, effects_1.call(getNearbyPropertyiesMapObjects, places)];
            case 55:
                mapObjects = _b.sent();
                if (!(mapObjects.length > 1)) return [3 /*break*/, 57];
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapZoom(-1))];
            case 56:
                _b.sent();
                _b.label = 57;
            case 57: return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapObjects(mapObjects))];
            case 58:
                _b.sent();
                return [3 /*break*/, 67];
            case 59: return [4 /*yield*/, effects_1.call(NearbyCallSaga_1.getFilterResults, filter, propertyCenter)];
            case 60:
                results = _b.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setResultItems(results, filter))];
            case 61:
                _b.sent();
                return [4 /*yield*/, effects_1.call(NearbyCallSaga_1.typeToPinStyle, filter)];
            case 62:
                icon = _b.sent();
                return [4 /*yield*/, effects_1.call(NearbyCallSaga_1.nearbyResultItemsToMapObjects, results, icon)];
            case 63:
                mapObjects = _b.sent();
                if (!(mapObjects.length > 1)) return [3 /*break*/, 65];
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapZoom(-1))];
            case 64:
                _b.sent();
                _b.label = 65;
            case 65: return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapObjects(mapObjects))];
            case 66:
                _b.sent();
                _b.label = 67;
            case 67: return [3 /*break*/, 0];
            case 68: return [2 /*return*/];
        }
    });
};
var watchMoreClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(NearbyAction_1.default.NEARBY_FILTER_MORE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapObjects([]))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setNearbyMore(true))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchMapObjectClick = function () {
    var payload, i, object, nearbyProperties, property, lang, propertyLink;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(NearbyAction_1.default.NEARBY_ON_OBJECT_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                i = payload.i;
                object = payload.object;
                return [4 /*yield*/, effects_1.select(getProperties)];
            case 2:
                nearbyProperties = _a.sent();
                property = nearbyProperties[i];
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 3:
                lang = _a.sent();
                if (!(property && property.id)) return [3 /*break*/, 5];
                propertyLink = propertyToUrl_1.propertyToUrl(lang, property.name, property.id, property.type);
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.globalSetUrl(propertyLink))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var watchMapObjectsClick = function () {
    var payload, objects, object, selectedProperty, lang, propertyLink;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(NearbyAction_1.default.NEARBY_ON_OBJECTS_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                objects = payload;
                if (objects.length !== 1)
                    return [3 /*break*/, 0];
                object = objects[0];
                return [4 /*yield*/, effects_1.select(getProeprtyByObject, object)];
            case 2:
                selectedProperty = _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 3:
                lang = _a.sent();
                propertyLink = propertyToUrl_1.propertyToUrl(lang, selectedProperty.name, selectedProperty.id, selectedProperty.type);
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.globalSetUrl(propertyLink))];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var watchNewPlaceClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(NearbyAction_1.default.NEARBY_NEARBY_ADD_PLACE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.showAddPlace(true))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchKeywordCheckSuggestion = function () {
    var keyword, suggestions;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.take(NearbyAction_1.default.NEARBY_ADD_PLACE_CHECK_SUGGESTION)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getKeyword)];
            case 2:
                keyword = _a.sent();
                if (!(keyword.length <= 2)) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setSuggestons(null))];
            case 3:
                _a.sent();
                return [3 /*break*/, 7];
            case 4: return [4 /*yield*/, effects_1.call(NearbyCallSaga_1.getSuggestions, keyword)];
            case 5:
                suggestions = _a.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setSuggestons(suggestions))];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [3 /*break*/, 0];
            case 8: return [2 /*return*/];
        }
    });
};
var watchKeywordFocusKeywordChange = function () {
    var payload, keyword;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(NearbyAction_1.default.NEARBY_ADD_PLACE_KEYWORD_CHANGE)];
            case 1:
                payload = (_a.sent()).payload;
                keyword = payload;
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setKeyword(keyword))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.checkSuggestion())];
            case 3:
                _a.sent();
                if (!!keyword) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setSelectedPlace(null))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var watchKeywordFocusBlur = function () {
    var isSelecting;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.take(NearbyAction_1.default.NEARBY_ADD_PLACE_KEYWORD_FOCUS)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setIsSuggesting(true))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.checkSuggestion())];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.take(NearbyAction_1.default.NEARBY_ADD_PLACE_KEYWORD_BLUR)];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getIsSelectingItem)];
            case 5:
                isSelecting = _a.sent();
                if (!!isSelecting) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setIsSuggesting(false))];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [3 /*break*/, 0];
            case 8: return [2 /*return*/];
        }
    });
};
var watchSuggestionItemClick = function () {
    var payload, suggestion, position, index;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 11];
                return [4 /*yield*/, effects_1.take(NearbyAction_1.default.NEARBY_ADD_PLACE_ITEM_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                suggestion = payload.suggestion;
                if (!!suggestion.position) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.call(NearbyCallSaga_1.getPlacePosition, suggestion.placeId)];
            case 2:
                position = _a.sent();
                suggestion.position = position;
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setSuggestionPostion(suggestion.placeId, position))];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4:
                index = payload.i;
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setSelectedPlace(__assign(__assign({}, suggestion), { name: suggestion.address })))];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setSuggestons(null))];
            case 6:
                _a.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setIsSuggesting(false))];
            case 7:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(300)];
            case 8:
                _a.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapZoom(-1))];
            case 9:
                _a.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setSmallMapZoom(-1))];
            case 10:
                _a.sent();
                return [3 /*break*/, 0];
            case 11: return [2 /*return*/];
        }
    });
};
var watchEstimateRoute = function () {
    var place, buildingPosition, commuteMethod, _a, path, min, t, value, unit, route, source, filter, icon, destination, mapObjects;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!true) return [3 /*break*/, 19];
                return [4 /*yield*/, effects_1.take(NearbyAction_1.default.NEARBY_ESTIMATE_ROUTE)];
            case 1:
                _b.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapObjects([]))];
            case 2:
                _b.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setSmallMapObjects([]))];
            case 3:
                _b.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapZoom(15))];
            case 4:
                _b.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setSmallMapZoom(16))];
            case 5:
                _b.sent();
                return [4 /*yield*/, effects_1.select(getSelectdPlace)];
            case 6:
                place = _b.sent();
                return [4 /*yield*/, effects_1.select(getPropertyLocation)];
            case 7:
                buildingPosition = _b.sent();
                return [4 /*yield*/, effects_1.select(getCommuteMethod)];
            case 8:
                commuteMethod = _b.sent();
                return [4 /*yield*/, effects_1.call(NearbyCallSaga_1.getRoute, place.position, buildingPosition, commuteMethod)];
            case 9:
                _a = _b.sent(), path = _a.path, min = _a.min;
                return [4 /*yield*/, effects_1.select(getTranslate)];
            case 10:
                t = _b.sent();
                value = min > 60 ? Math.round(min / 60 * 10) / 10 : Math.round(min);
                unit = min > 60
                    ? NearbyCommuteEstimatorState_1.NearbyCommuteDurationUnit.HOUR
                    : NearbyCommuteEstimatorState_1.NearbyCommuteDurationUnit.MIN;
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setNewPlaceTravalDuration(value, unit))];
            case 11:
                _b.sent();
                route = {
                    path: path,
                    kind: NearbymapState_1.NearbymapObjectKind.ROUTE,
                    center: buildingPosition,
                };
                source = {
                    kind: NearbymapState_1.NearbymapObjectKind.PIN,
                    center: buildingPosition,
                };
                return [4 /*yield*/, effects_1.select(getCurrentFilter)];
            case 12:
                filter = _b.sent();
                return [4 /*yield*/, effects_1.call(NearbyCallSaga_1.typeToPinStyle, filter)];
            case 13:
                icon = _b.sent();
                destination = {
                    icon: icon,
                    kind: NearbymapState_1.NearbymapObjectKind.MARKER,
                    center: place.position,
                };
                mapObjects = [];
                mapObjects.push(route);
                mapObjects.push(source);
                mapObjects.push(destination);
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapObjects(mapObjects))];
            case 14:
                _b.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setSmallMapObjects(mapObjects))];
            case 15:
                _b.sent();
                return [4 /*yield*/, effects_1.delay(200)];
            case 16:
                _b.sent();
                return [4 /*yield*/, effects_1.call(fitBounds)];
            case 17:
                _b.sent();
                return [4 /*yield*/, effects_1.call(fitSmallMapBounds)];
            case 18:
                _b.sent();
                return [3 /*break*/, 0];
            case 19: return [2 /*return*/];
        }
    });
};
var watchSelectedPlace = function () {
    var payload, place;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(NearbyAction_1.default.NEARBY_SET_SELECTED_PLACE)];
            case 1:
                payload = (_a.sent()).payload;
                place = payload;
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.clearRoute())];
            case 2:
                _a.sent();
                if (!place) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.estimateRoute())];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setKeyword(place.address))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var watchCommuteMethodChange = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(NearbyAction_1.default.NEARBY_SET_COMMUTE_METHOD)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.estimateRoute())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchResultItemClick = function () {
    var action, type, item, i, from, to, walkInfo, driveInfo, t, _a, results, filter, icon, mapObjects, walk, drive, places, mapObjects, propertyCenter, propertyName, propertyPin, walk, drive, route, newMapObjects, e_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!true) return [3 /*break*/, 30];
                return [4 /*yield*/, effects_1.take([
                        NearbyAction_1.default.NEARBY_RESULT_ITEM_CLICK,
                        NearbyAction_1.default.NEARBY_MY_PLACE_CLICK,
                    ])];
            case 1:
                action = _b.sent();
                type = action.type;
                item = action.payload.item;
                i = action.payload.i;
                return [4 /*yield*/, effects_1.select(getPropertyLocation)];
            case 2:
                from = _b.sent();
                to = item.position;
                _b.label = 3;
            case 3:
                _b.trys.push([3, 28, , 29]);
                return [4 /*yield*/, effects_1.call(NearbyCallSaga_1.getRoute, from, to, NearbyCommuteMethods_1.NearbyCommuteMethods.WALKING)];
            case 4:
                walkInfo = _b.sent();
                return [4 /*yield*/, effects_1.call(NearbyCallSaga_1.getRoute, from, to, NearbyCommuteMethods_1.NearbyCommuteMethods.DRIVE)];
            case 5:
                driveInfo = _b.sent();
                return [4 /*yield*/, effects_1.select(getTranslate)];
            case 6:
                t = _b.sent();
                _a = type;
                switch (_a) {
                    case NearbyAction_1.default.NEARBY_RESULT_ITEM_CLICK: return [3 /*break*/, 7];
                    case NearbyAction_1.default.NEARBY_MY_PLACE_CLICK: return [3 /*break*/, 16];
                }
                return [3 /*break*/, 24];
            case 7: return [4 /*yield*/, effects_1.select(getResultItems)];
            case 8:
                results = _b.sent();
                return [4 /*yield*/, effects_1.select(getCurrentPopNearbyTab)];
            case 9:
                filter = _b.sent();
                return [4 /*yield*/, effects_1.call(NearbyCallSaga_1.typeToPinStyle, filter)];
            case 10:
                icon = _b.sent();
                return [4 /*yield*/, effects_1.call(NearbyCallSaga_1.nearbyResultItemsToMapObjects, results, icon)];
            case 11:
                mapObjects = _b.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapObjects(mapObjects))];
            case 12:
                _b.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setResultItemActive(i, true))];
            case 13:
                _b.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapObjectActive(i, true))];
            case 14:
                _b.sent();
                walk = {
                    type: NearbyCommuteMethods_1.NearbyCommuteMethods.WALKING,
                    value: walkInfo.min,
                    unit: t.min,
                };
                drive = {
                    type: NearbyCommuteMethods_1.NearbyCommuteMethods.DRIVE,
                    value: driveInfo.min,
                    unit: t.min,
                };
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setResultItemDurations([walk, drive], i))];
            case 15:
                _b.sent();
                return [3 /*break*/, 24];
            case 16: return [4 /*yield*/, effects_1.select(getSavedPlaces)];
            case 17:
                places = _b.sent();
                mapObjects = places.map(function (it) { return ({
                    kind: NearbymapState_1.NearbymapObjectKind.WINDOW,
                    center: it.position,
                    title: it.price ? format_1.default.currency(it.price) : it.name,
                }); });
                return [4 /*yield*/, effects_1.select(NearbyCallSaga_1.getPropertyPosition)];
            case 18:
                propertyCenter = _b.sent();
                return [4 /*yield*/, effects_1.select(NearbyCallSaga_1.getPropertyName)];
            case 19:
                propertyName = _b.sent();
                propertyPin = {
                    kind: NearbymapState_1.NearbymapObjectKind.PIN,
                    center: propertyCenter,
                    title: propertyName,
                };
                mapObjects.push(propertyPin);
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapObjects(mapObjects))];
            case 20:
                _b.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMyPlaceItemActive(i, true))];
            case 21:
                _b.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapObjectActive(i, true))];
            case 22:
                _b.sent();
                walk = {
                    type: NearbyCommuteMethods_1.NearbyCommuteMethods.WALKING,
                    value: walkInfo.min,
                    unit: t.min,
                };
                drive = {
                    type: NearbyCommuteMethods_1.NearbyCommuteMethods.DRIVE,
                    value: driveInfo.min,
                    unit: t.min,
                };
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMyPlaceDurations([walk, drive], i))];
            case 23:
                _b.sent();
                return [3 /*break*/, 24];
            case 24:
                route = {
                    path: walkInfo.path,
                    kind: NearbymapState_1.NearbymapObjectKind.ROUTE,
                };
                return [4 /*yield*/, effects_1.delay(100)];
            case 25:
                _b.sent();
                return [4 /*yield*/, effects_1.select(getMapObjects)];
            case 26:
                newMapObjects = _b.sent();
                newMapObjects.push(route);
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapObjects(newMapObjects))];
            case 27:
                _b.sent();
                return [3 /*break*/, 29];
            case 28:
                e_1 = _b.sent();
                return [3 /*break*/, 29];
            case 29: return [3 /*break*/, 0];
            case 30: return [2 /*return*/];
        }
    });
};
var watchMarkerClick = function () {
    var payload, marker, i, items, item;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(NearbyAction_1.default.NEARBY_MARKER_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                marker = payload.object;
                i = payload.i;
                return [4 /*yield*/, effects_1.select(getResultItems)];
            case 2:
                items = _a.sent();
                item = items[i];
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.onResultItemClick(item, i))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchSavePlace = function () {
    var isGuest, place, result, saveStatus;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 17];
                return [4 /*yield*/, effects_1.take(NearbyAction_1.default.NEARBY_ON_SAVE_PLACE_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.isUserGuest)];
            case 2:
                isGuest = _a.sent();
                if (!isGuest) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setReturnState('ss'))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SignupAction_1.default.setPanelDim(true))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(100)];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SignupAction_1.default.setPanelActive(true))];
            case 6:
                _a.sent();
                return [3 /*break*/, 16];
            case 7: return [4 /*yield*/, effects_1.select(getCurrentPlace)];
            case 8:
                place = _a.sent();
                return [4 /*yield*/, effects_1.call(ProfileApiSaga_1.addPlaceApiSaga, place.name, place.address, place.position.lat, place.position.lng)];
            case 9:
                result = _a.sent();
                saveStatus = result.data.isSaved;
                if (!saveStatus) return [3 /*break*/, 11];
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setBigPopupLocalized('save_place_success', BigPopupState_1.BigPopupType.SUCCESS, 'success', 'savePlaceSuccess'))];
            case 10:
                _a.sent();
                return [3 /*break*/, 13];
            case 11: return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setBigPopupLocalized('save_place_failed', BigPopupState_1.BigPopupType.FAILED, 'failed', 'savePlaceFailed'))];
            case 12:
                _a.sent();
                _a.label = 13;
            case 13: return [4 /*yield*/, effects_1.delay(500)];
            case 14:
                _a.sent();
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.onFilterClick(DetailPopNearbyTabType_1.DetailPopNearbyTabType.MYPLACE))];
            case 15:
                _a.sent();
                _a.label = 16;
            case 16: return [3 /*break*/, 0];
            case 17: return [2 /*return*/];
        }
    });
};
var watchOnNearbyItemClick = function () {
    var payload, item, buildingName, referenceId, lang, type, url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(NearbyAction_1.default.NEARBY_ON_NEARBY_ITEM_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                item = payload.it;
                buildingName = item.name;
                referenceId = item.id;
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 2:
                lang = _a.sent();
                type = item.type === SfilterTypeGroup_1.SfilterType.BUYRENT ? SfilterTypeGroup_1.SfilterType.BUY : SfilterTypeGroup_1.SfilterType.RENT;
                return [4 /*yield*/, effects_1.call(propertyToUrl_1.propertyToUrl, lang, buildingName, referenceId, type)];
            case 3:
                url = _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.setUrl, url)];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var watchOnNearbyItemShow = function () {
    var payload, item, i, properties, mapObjects;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 10];
                return [4 /*yield*/, effects_1.take(NearbyAction_1.default.NEARBY_ON_NEARBY_ITEM_SHOW)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapObjects([]))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(50)];
            case 3:
                _a.sent();
                item = payload.it;
                i = payload.i;
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setNearbyItemIndexActive(i))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getProperties)];
            case 5:
                properties = _a.sent();
                return [4 /*yield*/, effects_1.call(getNearbyPropertyiesMapObjects, properties)];
            case 6:
                mapObjects = _a.sent();
                if (!(mapObjects.length > 1)) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapZoom(-1))];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8: return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapObjects(mapObjects))];
            case 9:
                _a.sent();
                return [3 /*break*/, 0];
            case 10: return [2 /*return*/];
        }
    });
};
var watchSetMapObjectActive = function () {
    var _loop_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _loop_1 = function () {
                    var payload, i, state, mapObjects, newMapObjects;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, effects_1.take(NearbyAction_1.default.NEARBY_MAP_OBJECT_ACTIVE)];
                            case 1:
                                payload = (_a.sent()).payload;
                                i = payload.i;
                                state = payload.state;
                                return [4 /*yield*/, effects_1.select(getMapObjects)];
                            case 2:
                                mapObjects = _a.sent();
                                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapObjects([]))];
                            case 3:
                                _a.sent();
                                newMapObjects = mapObjects.map(function (it, j) {
                                    return __assign(__assign({}, it), { active: j === i && state });
                                });
                                return [4 /*yield*/, effects_1.put(NearbyAction_1.default.setMapObjects(newMapObjects))];
                            case 4:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                };
                _a.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 3];
                return [5 /*yield**/, _loop_1()];
            case 2:
                _a.sent();
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
};
var nearbySagas = {
    watchFilterClick: watchFilterClick,
    watchMoreClick: watchMoreClick,
    watchMapObjectClick: watchMapObjectClick,
    watchMapObjectsClick: watchMapObjectsClick,
    watchNewPlaceClick: watchNewPlaceClick,
    watchKeywordFocusBlur: watchKeywordFocusBlur,
    watchKeywordFocusKeywordChange: watchKeywordFocusKeywordChange,
    watchKeywordCheckSuggestion: watchKeywordCheckSuggestion,
    watchSuggestionItemClick: watchSuggestionItemClick,
    watchSelectedPlace: watchSelectedPlace,
    watchCommuteMethodChange: watchCommuteMethodChange,
    watchEstimateRoute: watchEstimateRoute,
    watchResultItemClick: watchResultItemClick,
    watchMarkerClick: watchMarkerClick,
    watchSavePlace: watchSavePlace,
    watchOnNearbyItemClick: watchOnNearbyItemClick,
    watchOnNearbyItemShow: watchOnNearbyItemShow,
    watchSetMapObjectActive: watchSetMapObjectActive,
};
exports.nearbySagas = nearbySagas;
